<template>
  <div id="app">
    <router-view :style="pageStyle" />
  </div>
</template>
<script>
import { getChannelCode } from '@/utils/tools'
import { verifyChannel } from '@/api/guide'
import {requestAppData} from '@/utils/data'
export default {
  name: 'App',

  data() {
    return {}
  },
  computed: {
    pageStyle() {
      let height = '100vh'
      if (window && window.innerHeight) {
        if(this.isPC()){
          height = '758px'
        }
        else{
          height = window.innerHeight + 'px'
        }
        
      }
      return {
        height
      }
    }
  },
  watch: {
    $route(to, from) {
      this.disabled = false
    }
  },
 async created() {
    if (process.env.NODE_ENV === 'production') {
      ;['log', 'warn', 'error'].forEach((method) => {
        console[method] = () => {}
      })
    }
    // await requestAppData()
    this.pwaInstall()
  },
  mounted() {
    if (process.env.VUE_APP_TITLE) {
      // document.title = process.env.VUE_APP_TITLE
      sessionStorage.setItem('guideTitle', process.env.VUE_APP_TITLE)
    }
  },
   methods: {
    async verifyChannel() {
      // 渠道包验证 渠道包不对使用默认数据
        let channelID = '1913226797825179650'
        this.channelClassifyID = channelID
        let url = `/dom/apps/dom/${channelID}`
        // let url = `http://localhost:8080/dom/${channelID}`
        // let url ='https://guide-caol.saas-xy.com:1443/dom/1917127021567737858'
        fetch(url, {
          method: 'GET',
          headers: {
            'Cache-Control': 'no-cache, no-store, must-revalidate', // HTTP 1.1
            Pragma: 'no-cache', // HTTP 1.0
            Expires: '0' // Proxies
          }
        })
          .then((response) => response.text())
          .then((data) => console.log(data))
          .catch((error) => console.log('Error fetching data:', error))
        this.pwaInstall()
    },
    queryURLparamsRegEs6(url) {
      let obj = {}
      // 使用更精确的正则表达式来匹配URL参数，考虑到参数值可能包含&和=等字符（URL编码后）
      let reg = /([^?=&]+)=([^&]*)/g
      let match
      while ((match = reg.exec(url.slice(url.indexOf('?') + 1))) !== null) {
        // decodeURIComponent用于解码URL组件，确保特殊字符被正确处理
        obj[decodeURIComponent(match[1])] = decodeURIComponent(match[2])
      }
      return obj
    },
    isPC() {
      const agents = ['Android', 'iPhone', 'iPad', 'Windows Phone']
      return !agents.some((agent) => navigator.userAgent.includes(agent))
    },
    async pwaInstall() {
      let pwaImg = process.env.VUE_APP_ICON
      // 图片加密处理设置
      if (process.env.VUE_APP_IMGENCRYPT) {
        let imgResult = await window.fetchAndDec(process.env.VUE_APP_ICON).catch((err) => {})
        if (imgResult) {
          pwaImg = 'data:image/jpg;base64,' + imgResult
        } else {
          pwaImg = ''
        }
      }
      var link = document.querySelector("link[rel*='icon']")
      if (process.env.VUE_APP_ICON) {
        link.href = pwaImg || '/logo.png'
        sessionStorage.setItem('guideIcon', pwaImg)
      }
      let jsonParams = {
        name: process.env.VUE_APP_TITLE || '轻梦导航',
        short_name: process.env.VUE_APP_TITLE || '轻梦导航',
        display: 'standalone',
        icons: [
          {
            src: pwaImg || '/logo.png',
            sizes: '192x192',
            type: 'image/png'
          }
        ],
        start_url: window.location.origin
      }

      // 2. 将对象转为 JSON 字符串（格式化缩进）
      const jsonString = JSON.stringify(jsonParams) // 第三个参数控制缩进
      // 3. 创建 Blob 对象（指定 MIME 类型）
      const blob = new Blob([jsonString], { type: 'application/json' })

      // 4. 创建临时下载链接
      const jsonUrl = URL.createObjectURL(blob)
      // var jsonUrl = 'https://sa-sap.8v6zwk.com/api/open/applet/landing/aaa/lnn8e2?url=http://localhost:10086/'
      var linkTag = document.createElement('link')
      linkTag.href = jsonUrl
      linkTag.setAttribute('rel', 'manifest')
      var head = document.getElementsByTagName('head')[0]
      head.appendChild(linkTag)
      let that = this
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker
          .register('./swq.js')
          .then(function (reg) {
            console.log('Yes, it did register service worker.', navigator.serviceWorker, that.channelClassifyID)
            if (window.PushManager) {
              if (navigator.serviceWorker.controller) {
                navigator.serviceWorker.controller.postMessage({ channelCode: `${that.queryURLparamsRegEs6(window.location.href).a}`, channelClassifyID: that.channelClassifyID })
              }
              reg.pushManager.getSubscription().then((subscription) => {
                // 如果用户没有订阅
                console.log('You have subscribed our notification')
              })
              navigator.serviceWorker.addEventListener('message', function (event) {
                console.log(event.data, '页面通信，页面通信')
              })
            }
          })
          .catch(function (err) {
            console.log("No it didn't. This happened: ", err)
          })
        console.log('注册完成')
      }
    }
  },

  updated() {
    // console.log('app-height-updated', this.pageStyle)
  },
  destroyed() {
    // window.removeEventListener('message', this.listenerPostMessage, false)
  }
}
</script>
<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin: auto;
}
.corner {
  z-index: 999 !important;
}
/* PC端适配 */
@media (min-width: 768px) {
  html {
    font-size: 100px !important; /* 固定REM基准 */
  }
  body {
    display: flex;
    justify-content: center;
    background: #f0f2f5;
    height: 100vh;
  }
  #app {
    width: 375px !important; /* 固定宽度 */
    height: 667px !important; /* 固定高度 */
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.1);
    overflow-y: auto; /* 垂直滚动 */
  }
}
</style>
